import { isSupportedNetwork, loadContracts } from "./contractsInteractions";
import { loadTrades, subscribeToPositionsManagerEvents } from "./positionsManagerInteractions";
import {
  allContractsLoaded,
  tradesLoaded,
  lpTradesLoaded,
  allTradesLoaded,
  allLpTradesLoaded,
  marketsLoaded,
  marketsSettled,
  liquidationTradesLoaded
} from "../actions/actions.js";
import { loadMarkets, periodicallyUpdateMarketBasePrices, subscribeToMarketFactoryEvents } from "./marketsInteractions";
import { loadExpirationTimes } from "./dateUtilsInteractions";
import { loadAllTokenPairs, loadPositionTokens, loadLPPositionTokens, updateUnderlyingMarketPrice } from "./tokensInteractions";
import { loadDepositAndWithdrawalEvents, loadSettleEvents, subscribeToUserBalancesEvents } from "./balancesInteractions";
import { loadMarginAccountData, loadMarginPoolData, loadMarginPoolEvents, subscribeToMarginPoolEvents } from "./marginInteractions";
import { Web3Provider } from "@ethersproject/providers";
import { batch } from "react-redux";

export const init = async (web3, networkId, userAddress, dispatch) => {
  // TODO: v2 zasto se negde kao provider koristi web3 a negde provider?
  console.log("Init called in rootInteractions");
  // localStorage.setItem("ttl", Date.now());
  const provider = new Web3Provider(window.ethereum);
  let startTime = new Date();

  // check if on right network
  const supportedNetwork = await isSupportedNetwork(networkId, dispatch);
  if (!supportedNetwork) {
    return;
  }

  const contracts = await loadContracts(web3, networkId, dispatch);
  console.log("Contracts loaded in: " + (new Date() - startTime) + " ms");
  //console.log(networkId)
  dispatch(allContractsLoaded(contracts));
  const {
    gammaContractsRegistry,
    uniswapAdapter,
    marketRegistry,
    marketFactory,
    dateUtils,
    priceUtils,
    dydxMath,
    userBalances,
    tokenRegistry,
    positionsManager,
    marginPool,
    interestRateModel,
    loadHelper,
    lpManager,
    settlementManager,
    volRangeMarketSingleton,
    userBalancesVault
  } = contracts;

  const gammaContractsRegistryAddress = localStorage.getItem("gammaContractsRegistryAddress");
  if (gammaContractsRegistryAddress) {
    if (gammaContractsRegistryAddress !== gammaContractsRegistry._address) {
      localStorage.setItem("gammaContractsRegistryAddress", gammaContractsRegistry._address);
      localStorage.setItem("notifications", "{}");
    }
  } else {
    localStorage.setItem("gammaContractsRegistryAddress", gammaContractsRegistry._address);
  }

  // date utils

  // load token pairs
  const tokenPairs = await loadAllTokenPairs(provider, web3, loadHelper, tokenRegistry, userBalances, userAddress, dispatch);

  // load under price
  // const underPriceBN = await updateUnderlyingMarketPrice(tokenPairs, loadHelper, dispatch);

  // markets
  // const markets = await loadMarkets(loadHelper, riskFreeRate, web3, marketFactory, userBalances, dispatch);

  const riskFreeRate = tokenPairs[0].riskFreeRate / 100; // TODO: v1 this is a budzotina

  const underPriceBN = await updateUnderlyingMarketPrice(tokenPairs, loadHelper, dispatch); // returns avg underlying price

  // const [underPriceBN, markets, trades, settlementsStream] = await Promise.all([
  const [markets, settlementsStream] = await Promise.all([
    loadMarkets(loadHelper, riskFreeRate, web3, marketFactory, userBalances, underPriceBN, dispatch),
    // loadTrades(positionsManager, lpManager, settlementManager, userBalances, userAddress),
    userBalances.getPastEvents("Settlement", {
      fromBlock: 0,
      toBlock: "latest"
    })
  ]);

  dispatch(
    marketsLoaded(
      markets.map(market => market.immutableAttributes),
      markets.map(market => market.mutableAttributes)
    )
  );
  const trades = await loadTrades(positionsManager, lpManager, settlementManager, userBalances, userAddress);
  // loadSettleEvents(userBalances, dispatch)

  const { longShortTrades, lpTrades, liquidationTrades } = trades;

  const marketsImmutable = markets.map(market => market.immutableAttributes);

  //my trades
  // const { longShortTrades, lpTrades } = await loadTrades(positionsManager, lpManager, settlementManager, userBalances, userAddress);

  batch(() => {
    dispatch(tradesLoaded(longShortTrades));
    dispatch(lpTradesLoaded(lpTrades));
    dispatch(liquidationTradesLoaded(liquidationTrades));
    dispatch(marketsSettled(settlementsStream));
  });

  // position and lp tokens
  await Promise.all([
    loadPositionTokens(
      provider,
      web3,
      loadHelper,
      userBalances,
      markets.map(m => m.immutableAttributes),
      userAddress,
      dispatch
    ),
    loadLPPositionTokens(web3, loadHelper, lpManager, marketsImmutable, userBalances, userAddress, underPriceBN, dispatch),
    loadMarginPoolEvents(marginPool, userBalances, lpManager, userAddress, dispatch),
    loadMarginPoolData(loadHelper, marginPool, underPriceBN, gammaContractsRegistry, dispatch),
    loadMarginAccountData(userAddress, loadHelper, marginPool, userBalances, underPriceBN, gammaContractsRegistry, dispatch),
    loadExpirationTimes(dateUtils, dispatch),
    loadDepositAndWithdrawalEvents(userBalancesVault, userAddress, dispatch)
  ]);

  // periodically fetch data
  // subscribeToNewBlocks(web3, marketRegistry, positionsManager, userAddress, dispatch);
  const block = await web3.eth.getBlock("latest");
  const timestamp = block.timestamp;
  const nonExpiredMarketIds = [];
  for (const market of markets) {
    const isSettled = market.mutableAttributes.isSettled;
    const expirationTime = Number(market.immutableAttributes.expirationTime);
    const marketIsExpired = isSettled || expirationTime < timestamp;
    if (!marketIsExpired) {
      const id = Number(market.immutableAttributes.marketId);
      nonExpiredMarketIds.push(id);
    }
  }
  //all trades
  // todo: should we add liquidation trades here?
  // todo: why do we call load trades 2x? can we call it once?
  const { longShortTrades: allLongShortTrades, lpTrades: allLpTrades } = await loadTrades(
    positionsManager,
    lpManager,
    settlementManager,
    userBalances,
    null,
    nonExpiredMarketIds
  );
  batch(() => {
    dispatch(allTradesLoaded(allLongShortTrades));
    dispatch(allLpTradesLoaded(allLpTrades));
  });
  periodicallyUpdateMarketBasePrices(loadHelper, gammaContractsRegistry, userBalances, marginPool, userAddress, dispatch);
  subscribeToPositionsManagerEvents(
    provider,
    riskFreeRate,
    web3,
    positionsManager,
    lpManager,
    settlementManager,
    userAddress,
    userBalances,
    loadHelper,
    marginPool,
    gammaContractsRegistry,
    dispatch
  );
  subscribeToMarginPoolEvents(provider, web3, loadHelper, marginPool, underPriceBN, userBalances, gammaContractsRegistry, userAddress, dispatch);
  subscribeToMarketFactoryEvents(provider, riskFreeRate, web3, marketFactory, loadHelper, userBalances, userAddress, dispatch);
  subscribeToUserBalancesEvents(
    provider,
    web3,
    userAddress,
    userBalances,
    userBalancesVault,
    tokenRegistry,
    positionsManager,
    marginPool,
    gammaContractsRegistry,
    riskFreeRate,
    loadHelper,
    dispatch
  );
};

export const subscribeToNewBlocks = async (web3, exchangeRegistry, positionsManager, userAccount, dispatch) => {
  let subscription = web3.eth
    .subscribe("newBlockHeaders", (error, result) => {
      if (!error) {
        console.log("New block");

        // TODO: v2 for now, just subscribe to new block, and do nothing
        // In production, this will be main method to sync with blockchain updates
        // not 30 seconds fetchers
        //loadLPPositionTokens(web3, loadHelper, gammaContractsRegistry, exchangeRegistry, exchangeAccounts, userAccount, dispatch);

        return;
      }

      console.error(error);
    })
    .on("connected", subscriptionId => {
      //console.log("Connected:", subscriptionId);
    })
    .on("error", console.error);
};
